import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  margin: auto;
  justify-content: center;
  padding: ${({ theme }): number => theme.sizes[6]}px 0;
`;
